import app from "../_app";
import axios from "axios";
import {quantitiesInit} from "./quantity";
import {addToCartHandler} from "./addToCart";
import {getBundleComponents, renderBundleComponentsHTML} from "./bundleComponents";

const microcart = document.querySelector('.js-microcart');
const defaultTitles = ['Title', 'Titre', 'Titel'];

async function fetchAdditionalProductData(productIds) {
  const requests = productIds.map(id => fetch(`${Shopify.routes.root}products/${id}.json`).then(response => response.json()));
  const productsData = await Promise.all(requests);

  return productsData.reduce((acc, product) => {
      acc[product.product.id] = product.product.variants[0].compare_at_price * 100;
      return acc;
  }, {});
}

async function renderMicrocartProduct(item, compareAtPriceMap) {
    const compareAtPrice = compareAtPriceMap[item.product_id];
    const isOrderProtection = item.product_type === 'ShipWill';
    const bundleItemsJson = item.properties?._bundle_selected_items;
    const bundleComponents = bundleItemsJson ? await getBundleComponents(bundleItemsJson) : [];
    const bundleComponentsHTML = bundleComponents.length
        ? `<div class="mt-2">${renderBundleComponentsHTML(bundleComponents, 'fs-250')}</div>`
        : '';

    let optionsHTML = '';
    if (item.options_with_values && item.options_with_values.length > 0 && !defaultTitles.includes(item.options_with_values[0].name)) {
        optionsHTML = item.options_with_values.map(option => `<span>${option.name}:</span>&nbsp;<span>${option.value}</span>`).join('');
    }

    const variantOptionsHTML = optionsHTML
        ? `<div class="d-flex fs-250 mt-2">${optionsHTML}</div>`
        : '';

    let priceHTML = `<span class="fw-500">${app.currency(item.price)}</span>`;

    if (compareAtPrice && compareAtPrice > item.price) {
        priceHTML = `
            <span class="microcart-product__price--old d-block fs-250 c--gray">${app.currency(compareAtPrice)}</span>
            <span class="d-block fw-500">${app.currency(item.price)}</span>
        `;
    }

    const image = item.image ? `<img src="${item.image.replace('.png', '_x250.png')}" alt="${item.title}" loading="lazy">` : '';

    return `
        <div class="microcart-product">
          <div class="d-flex p-3 p-lg-4 gap-3">
            <div>
              ${isOrderProtection ? 
                `<picture class="microcart-product__image img img--t">
                  ${image}
                </picture>` :
                `<a href="${item.url}">
                  <picture class="microcart-product__image img img--t">
                    ${image}
                  </picture>
                </a>`
              }
            </div>
            <div class="grow-1 pt-1">
              <div class="microcart-product__content">
                <div class="d-flex justify-content-between gap-3">
                  <div>
                    ${isOrderProtection ? 
                      `<div>
                        <h3 class="heading heading--sm fs-lg-300">${item.product_title}</h3>
                        ${variantOptionsHTML}
                        ${bundleComponentsHTML}
                      </div>` :
                      `<a href="${item.url}">
                        <h3 class="heading heading--sm fs-lg-300">${item.product_title}</h3>
                        ${variantOptionsHTML}
                        ${bundleComponentsHTML}
                      </a>`
                    }
                  </div>
                  <div>
                    <div class="text-end">
                      ${priceHTML}
                    </div>
                  </div>
                </div>
                <div class="mt-3 js-quantity">
                  <div class="d-flex align-items-center justify-content-between">
                    <div class="microcart-product__quantity d-flex gap-3">
                      <div class="input__group px-0">
                        <button type="button" class="microcart-product__quantity-min js-quantity-min">
                          <svg width="12" height="1" viewBox="0 0 12 1" fill="#121212" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.75 0.108643H11.25V0.891282H0.75V0.108643Z" fill="#121212"/>
                          </svg>
                        </button>
                        <input type="number" name="updates[]" id="updates_${item.key}" value="${item.quantity}" min="0"
                          class="input__field js-quantity-input" data-key="${item.key}">
                        <button type="button" class="microcart-product__quantity-plus js-quantity-plus">
                          <svg width="12" height="11" viewBox="0 0 12 11" fill="#121212" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.75 5.00307H5.50308V0.25H6.49693V5.00307H11.25V5.99693H6.49693V10.75H5.50308V5.99693H0.75V5.00307Z" fill="#121212"/>
                          </svg>
                        </button>
                      </div>
                      <button class="btn-add-to-wishlist js-wishlist-trigger d-flex" data-product-handle="${item.handle}">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" fill="none" class="js-wishlist-trigger-svg">
                            <path class="js-wishlist-trigger-svg" fill="#121212" d="M8.8832 1.0658C10.0472.3579 11.348.1943 12.5256.62l.1799.07.165.0704.1563.0755c1.3332.6822 2.1186 2.1036 2.1186 3.8733 0 1.6974-1.1635 3.643-3.3624 5.7272-.614.582-1.2863 1.1523-1.9986 1.6993l-.4148.3125-.409.2966-.3754.2623-.2974.1992-.2894.1809-.2098-.1319-.1853-.121-.3708-.2535-.2911-.2062-.3126-.2277-.4279-.3227c-.7058-.5426-1.3736-1.1094-1.984-1.688C2.0179 8.3519.8545 6.4065.8545 4.709c0-1.8907.8026-3.328 2.2046-3.975 1.3446-.6058 3.0472-.3363 4.5381.7273l.3046.2284.148-.0039.1207-.1028.1692-.1389.1703-.1291.1805-.1262.1927-.123Zm-.33 1.3506-.5369.5354-.4309-.3646c-.8818-.789-1.8792-1.2316-2.8035-1.287l-.1969-.006-.2056.007c-.3404.023-.6674.1035-.9713.2416-1.0774.4807-1.6908 1.6411-1.6908 3.1661 0 1.8487 1.812 3.9582 3.6289 5.5745l.3629.3165.3598.3019.3535.2862c.0583.0462.116.0918.1734.1367l.3381.2598.3237.2407.3063.2202.2854.1982a16.25 16.25 0 0 0 .134.0906l.3888-.2715.3705-.2683.425-.3189.3075-.2386.323-.2578.3349-.2758c.0566-.0474.1136-.0955.1708-.1442l.3461-.3004c.0581-.0513.1163-.1032.1745-.1557l.3495-.322c1.5704-1.4785 3.0753-3.3458 3.0753-5.072 0-1.5251-.7127-2.7351-1.8898-3.216-1.2253-.5092-2.6798-.1477-3.8062.9234Z"/>
                        </svg>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" width="16" height="14" viewBox="0 0 16 14" class="js-wishlist-trigger-svg">
                            <path class="js-wishlist-trigger-svg" fill="#121212" d="M8.8832 1.1786C10.0472.4707 11.348.307 12.5256.7327l.1799.07.165.0705.1563.0754c1.3332.6823 2.1186 2.1037 2.1186 3.8734 0 1.6974-1.1635 3.643-3.3624 5.7271-.614.582-1.2863 1.1524-1.9986 1.6993l-.4148.3126-.409.2965-.3754.2624-.2974.1992-.2894.1809-.2098-.1319-.1853-.121-.3708-.2535-.2911-.2062-.3126-.2278-.4279-.3226c-.7058-.5427-1.3736-1.1095-1.984-1.6881C2.0179 8.4647.8545 6.5192.8545 4.8218c0-1.8908.8026-3.328 2.2046-3.975C4.4037.241 6.1063.5104 7.5972 1.574l.3046.2285.148-.004.1207-.1028.1692-.1388.1703-.1292.1805-.1261.1927-.123Z"/>
                        </svg>
                      </button>
                    </div>
                    <div class="text-end">
                      <span data-vid="${item.id}" class="microcart-product__remove js-quantity-remove fs-300 link-grow">${app.translationHelper('cart.remove')}</span>
                    </div>
                  </div>
                  <div class="product__error-message c--orange fs-200 js-addtocart-error"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      `;
}

export const toggleMicrocart = async (refresh) => {
    if (microcart.hasAttribute('data-open') && refresh !== true) {
        microcart.removeAttribute('data-open');
        app.unlockBody();
    } else {
        app.lockBody();
        microcart.setAttribute('data-open', '');

        let response = await axios.get(`${Shopify.routes.root}cart.js`);

        const microcartProducts = microcart.querySelector('.js-microcart-products');
        const microcartCartDiscounts = microcart.querySelector('.js-microcart-cart-discounts');
        const microcartTotal = microcart.querySelector('.js-microcart-total');
        const shipping = microcart.querySelector('.js-cart-shipping');
        const headerNotification = document.querySelector('.js-microcart-notification');

        microcartTotal.innerHTML = '';
        microcartCartDiscounts.innerHTML = '';

        const productHandles = response.data.items.map(item => item.handle);
        const compareAtPriceMap = await fetchAdditionalProductData(productHandles);

        if (response.status === 200) {
            let data = response.data;
            const cartDiscounts = data.cart_level_discount_applications;

            microcart.removeAttribute('data-empty');
            headerNotification.setAttribute('data-active', '');
            headerNotification.dataset.amount = data.item_count;

            const cartItemsCountElements = [...document.querySelectorAll('.js-cart-items-count')];
            cartItemsCountElements.map(cartItemsCount => cartItemsCount.setAttribute('data-count', data.items.length));

            const itemsHTML = await Promise.all(data.items.map(item => renderMicrocartProduct(item, compareAtPriceMap)));
            microcartProducts.innerHTML = itemsHTML.join('').replace(/\n\s+/g, '');

            let extraCosts = 0;

            if (shipping) {
                if (data.total_price < +shipping.dataset.threshold) {
                    extraCosts += +shipping.dataset.costs;
                    shipping.removeAttribute('data-above');
                } else {
                    shipping.setAttribute('data-above', '');
                }
            }

            if (cartDiscounts.length > 0) {
                microcartCartDiscounts.classList.remove('d-none');
                microcartCartDiscounts.innerHTML = cartDiscounts.map(cartDiscount => {
                    return `
                        <div class="d-flex justify-content-between pt-3">
                            <span class="fs-400 fw-500">${cartDiscount.title}</span>
                            <span class="fs-400 fw-500">-${app.currency(cartDiscount.total_allocated_amount)}</span>
                        </div>
                    `;
                }).join('').replace(/\n\s+/g, '');
            }

            microcartTotal.innerHTML = app.currency(data.total_price + extraCosts);

            if (data.item_count === 0) {
                microcart.setAttribute('data-empty', '');
                headerNotification.dataset.amount = 0;
            }

            const quantities = [...document.querySelectorAll(".js-quantity")];
            quantities.map(quantity => quantitiesInit(quantity, true));
        }
    }
}

if (microcart) {
    const triggers = [...document.querySelectorAll('.js-microcart-trigger')];
    const cartUpsellsTriggers = [...document.querySelectorAll('.js-cartupsell-add')];

    triggers.map(trigger => trigger.addEventListener('click', toggleMicrocart));

    cartUpsellsTriggers.map(cartUpsellsTrigger => cartUpsellsTrigger.addEventListener('submit', (e) => {
        addToCartHandler(e);
    }));

    const $slider = document.querySelector('.js-microcart-slider');
    if ($slider) {
        const $prev = $slider.querySelector('.js-microcart-slider-prev');
        const $next = $slider.querySelector('.js-microcart-slider-next');
        const width = $slider.querySelector('.product-slider__track').querySelector('div')?.clientWidth + 30;

        if ($prev && $next) {
            $prev.addEventListener('click', () => {
                $slider.querySelector('.product-slider__track').scrollLeft -= width;
            });
            $next.addEventListener('click', () => {
                $slider.querySelector('.product-slider__track').scrollLeft += width;
            });
        }
    }
}
